import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";

const COOKIE_KEY = "mg_cookie_consent";

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, "accepted");
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(COOKIE_KEY, "declined");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", bounce: 0.2 }}
          className="fixed bottom-3 left-3 right-3 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[90] bg-card border border-border rounded-2xl shadow-xl p-4 md:p-5"
        >
          <div className="flex items-start gap-3">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
              <Cookie className="w-4.5 h-4.5 md:w-5 md:h-5 text-primary" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-heading font-bold text-foreground text-sm mb-0.5">Wir verwenden Cookies</h4>
              <p className="text-muted-foreground text-xs font-body leading-snug mb-3">
                Diese Website verwendet Cookies, um Ihr Nutzungserlebnis zu verbessern.
              </p>

              <div className="flex gap-2">
                <Button size="sm" onClick={accept} className="text-xs h-8 px-4 bg-secondary text-primary-foreground font-bold outline outline-[0.5pt] outline-white shadow-[0_0_20px_rgba(255,255,255,0.3)] [text-shadow:_0_1px_2px_rgba(0,0,0,0.3)] hover:bg-secondary/90">
                  Akzeptieren
                </Button>
                <Button size="sm" variant="outline" onClick={decline} className="text-xs h-8 px-4">
                  Ablehnen
                </Button>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent;
